import useAudioPlayerStore from '@/client/stores/useAudioPlayerStore';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';

interface Props {
  className?: ClassValue;
}

export function AudioPlayerPlayPauseButton({ className }: Props) {
  const { player } = useAudioPlayerStore();

  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    player.appendOnPlaybackStatusUpdateCallback(setIsPlaying);
    return () => {
      player.removeOnPlaybackStatusUpdateCallback(setIsPlaying);
    };
  }, [player]);

  const togglePlay = useCallback(() => {
    if (!player.isCurrentlyPlaying()) {
      player.play();
    } else {
      player.pause();
    }
  }, [player]);

  return (
    <Button className={cn('cursor-pointer', className)} onClick={togglePlay} aria-label={isPlaying ? 'Pause' : 'Play'}>
      {isPlaying ? 'Pause' : 'Play'}
    </Button>
  );
}
